import { useState, useRef } from 'react'
import { KmlUploadDialog as KmlUploadDialogComponent } from '../dialogs/KmlUploadDialog'
import { uploadKmlAPI } from '@services/kmlAPI'
import { useLoading } from '@contexts/LoadingContext'
import { useError } from '@contexts/ErrorContext'

export const useKmlUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null)
    const [showDialog, setShowDialog] = useState(false)
    const fileInputRef = useRef(null)

    const { showLoading, hideLoading } = useLoading()
    const { showError } = useError()

    const triggerFileSelect = () => {
        fileInputRef.current?.click()
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if (!file) return

        setSelectedFile(file)
        setShowDialog(true)

        // Reset input so the same file can be re-selected
        e.target.value = ''
    }

    const handleSubmit = async (epsilon) => {
        if (!selectedFile) return

        showLoading('Converting KML/KMZ...')

        const response = await uploadKmlAPI(selectedFile, epsilon)

        if (response instanceof Blob) {
            // Strip extension from original file name and append _output.zip
            const originalName = selectedFile.name.replace(/\.[^/.]+$/, '')
            const url = window.URL.createObjectURL(response)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${originalName}_output.zip`)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        } else {
            showError(response?.message || 'An unexpected error occurred while converting the file.')
        }

        hideLoading()
        setSelectedFile(null)
        setShowDialog(false)
    }

    const handleCancel = () => {
        setSelectedFile(null)
        setShowDialog(false)
    }

    const KmlUploadDialog = (
        <>
            <input
                ref={fileInputRef}
                type="file"
                accept=".kml,.kmz"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
            {showDialog && selectedFile && (
                <KmlUploadDialogComponent
                    showDialog={(val) => {
                        if (!val) handleCancel()
                    }}
                    onSubmit={handleSubmit}
                    fileName={selectedFile.name}
                />
            )}
        </>
    )

    return { triggerFileSelect, KmlUploadDialog }
}
